import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialIndoorMapsState, { LAYER_DEFAULTS_VERSION, resolveLayerVisibility } from './indoor-maps-initial-state';
import { IndoorDateRange, IndoorFloor, IndoorForklift, IndoorPeriod, LayerGroupKey } from '../models/indoor-maps.model';
import { IndoorHourWindow, IndoorView } from '../models/indoor-analytics.model';

const indoorMapsSlice = createSlice({
    name: 'indoorMapsSlice',
    initialState: initialIndoorMapsState,
    reducers: {
        setSelectedCompany(state, { payload }: PayloadAction<string | null>) {
            state.selectedCompany = payload;
            state.selectedFloor = null;
            state.floors = [];
            state.floorForklifts = [];
            state.selectedForklifts = [];
        },
        setSelectedFloor(state, { payload }: PayloadAction<string | null>) {
            if (state.selectedFloor !== payload) state.floorForklifts = [];
            state.selectedFloor = payload;
        },
        setFloors(state, { payload }: PayloadAction<IndoorFloor[]>) {
            state.floors = payload;
            if (state.selectedFloor && !payload.some(x => x.floorId === state.selectedFloor)) {
                state.selectedFloor = null;
                state.floorForklifts = [];
            }
        },
        setFloorForklifts(state, { payload }: PayloadAction<IndoorForklift[]>) {
            state.floorForklifts = payload;
            state.selectedForklifts = state.selectedForklifts.filter(id => payload.some(x => x.forkliftId === id));
        },
        setSelectedForklifts(state, { payload }: PayloadAction<string[]>) {
            state.selectedForklifts = payload;
        },
        setPeriod(state, { payload }: PayloadAction<IndoorPeriod>) {
            state.period = payload;
        },
        setDates(state, { payload }: PayloadAction<IndoorDateRange>) {
            state.dates = payload;
        },
        setLayerVisible(state, { payload }: PayloadAction<{ key: LayerGroupKey; visible: boolean }>) {
            state.layerVisibility = { ...resolveLayerVisibility(state), [payload.key]: payload.visible };
            state.layerDefaultsVersion = LAYER_DEFAULTS_VERSION;
        },
        setIs3D(state, { payload }: PayloadAction<boolean>) {
            state.is3D = payload;
        },
        setView(state, { payload }: PayloadAction<IndoorView>) {
            state.view = payload;
        },
        setHours(state, { payload }: PayloadAction<IndoorHourWindow | null>) {
            state.hours = payload;
        }
    }
});

export const {
    setSelectedCompany,
    setSelectedFloor,
    setFloors,
    setFloorForklifts,
    setSelectedForklifts,
    setPeriod,
    setDates,
    setLayerVisible,
    setIs3D,
    setView,
    setHours
} = indoorMapsSlice.actions;

export default indoorMapsSlice.reducer;
